import { get } from 'lodash';

const root = (state) => get(state, 'PurchaseOrderState.createEditReceipt');

export const getAllSiteItemsLoading = (state) =>
  get(root(state), 'getAllSiteItems.loading');
export const getAllSiteItemsResult = (state) =>
  get(root(state), 'getAllSiteItems.data');
export const getAllSiteItemsErrors = (state) =>
  get(root(state), 'getAllSiteItems.errors');

export const postSaveReceiptLoading = (state) =>
  get(root(state), 'postSaveReceipt.loading');
export const postSaveReceiptResult = (state) =>
  get(root(state), 'postSaveReceipt.data');
export const postSaveReceiptErrors = (state) =>
  get(root(state), 'postSaveReceipt.errors');

export const getReceiptDetailsLoading = (state) =>
  get(root(state), 'getReceiptDetails.loading');
export const getReceiptDetailsResult = (state) =>
  get(root(state), 'getReceiptDetails.data');
export const getReceiptDetailsErrors = (state) =>
  get(root(state), 'getReceiptDetails.errors');



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/state/createEditReceipt/selectors.js